import { colors } from "../../../utils/colors";
import { hierarchyTableLayout } from "../Constants/constants";

export const revenueAndBilledHoursStyles = {
  contentContainer: {
    bgcolor: colors.white,
    borderRadius: 2,
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: "flex",
    maxHeight: "68.5vh",
    flexDirection: "column",
    overflow: "hidden",
  },
  contentStack: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  tableContainer: {
    flex: 1,
    minHeight: 0,
    maxHeight: "calc(100vh - 12rem)",
    width: "100%",
    maxWidth: "100%",
    boxShadow: "none",
    borderRadius: hierarchyTableLayout.borderRadiusMd,
    overflow: "auto",
    backgroundColor: colors.white,
    position: "relative",
  },
  errorText: {
    justifyContent: "center",
    width: "100%",
    height: "100%",
    alignItems: "center",
    display: "flex",
  },
};
